import { refundPayment as TEXT } from 'locales/en/transaction';
import yup from 'utils/yupHelpers';
import { priceForAPI } from 'utils/price';

const schema = yup.object().shape({
  reason_option: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(TEXT.errors.reason_option.required),
  }),
  reason: yup.string(),
  amount: yup.string().when('$maxAmount', (maxAmount) => {
    return yup
      .string()
      .test('isGreat', TEXT.errors.amount.max(maxAmount), (value) => {
        return priceForAPI(value) <= priceForAPI(maxAmount);
      })
      .required(TEXT.errors.amount.required);
  }),
});

export default schema;
